import { Component, OnInit } from '@angular/core';
import { KeyAndValueModel } from '../../models/key-and-value.model';
import { TermsService } from '../../services/Terms.service';

@Component({
    selector: 'terms',
    templateUrl: 'terms.component.html',
    styleUrls: ['terms.component.scss']
})
export class TermsComponent implements OnInit {
  Menuoption = 'center';
  Settingicon = true;
  data : KeyAndValueModel[]=[]
  constructor(private service:TermsService) { }

  ngOnInit(): void {
    this.service.getAll()
    .subscribe(result=>{
        this.data = result;
    })
  }
}
